import { cn, InputOTP, InputOTPGroup, InputOTPSlot, REGEXP_ONLY_DIGITS } from '@cibli/shared';

type OtpInputProps = {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  small?: boolean;
};

export default function OtpInput({
  value,
  onChange,
  onComplete,
  disabled,
  autoFocus = true,
  maxLength = 6,
  small = false,
}: OtpInputProps) {
  return (
    <InputOTP
      maxLength={maxLength}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      autoFocus={autoFocus}
      pattern={REGEXP_ONLY_DIGITS}
      containerClassName="w-full max-w-full min-w-0 justify-center"
      disabled={disabled}
      render={({ slots }) => (
        <InputOTPGroup className="flex w-full min-w-0 items-center justify-center gap-[2%] sm:gap-3">
          {slots.map((slot, index) => (
            <InputOTPSlot
              key={index}
              {...slot}
              className={cn(
                'bg-white flex-1 min-w-0 max-w-14 basis-0',
                small
                  ? 'h-12 min-h-12 sm:h-14 sm:min-h-14 text-lg sm:text-xl rounded-xl'
                  : 'h-14 min-h-14 sm:h-16 sm:min-h-16 text-2xl sm:text-3xl rounded-2xl',
              )}
            />
          ))}
        </InputOTPGroup>
      )}
    />
  );
}
